import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=bb5970b4&scoped=true&"
import script from "./alert-dialog.vue?vue&type=script&lang=js&"
export * from "./alert-dialog.vue?vue&type=script&lang=js&"
import style0 from "./alert-dialog.vue?vue&type=style&index=0&id=bb5970b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5970b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
